import { useMutation } from "@apollo/client";
import { SAVE_BPM_ROLE_ASSIGNMENT } from "../api/save-bpm-role-assignment";
import { GET_BPM_ROLE_ASSIGNMENT_LIST } from "@/modules/admin-panel/features/bpm-roles/list";
import { useNotification } from "@/shared/feedback/notification";
import { useTranslations } from "use-intl";
import { FieldsType } from "./types";

export function useBpmRoleAssignment({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const t = useTranslations("Bpm");
  const notify = useNotification();

  const [saveBpmRole] = useMutation(SAVE_BPM_ROLE_ASSIGNMENT, {
    refetchQueries: [GET_BPM_ROLE_ASSIGNMENT_LIST],
  });

  const save = async (values: FieldsType) => {
    await saveBpmRole({ variables: { assignment: values } });

    notify?.success({
      message: t("Bpm role assignment saved"),
    });

    afterSubmit?.();
  };

  return {
    save,
  };
}
